import { defineStore } from "pinia";

import { ICreateMessagePost, IMessage, IBox, IReplyMessagePost } from "@/modules/Messaging/messagingDomain";
import { createNewMessage, replyMessage, getMessages, messagesAction } from "@/api/messagingApi";


interface IMessageState {
  messages: IMessage[]
  boxes: IBox[]
}

const state: IMessageState = {
  messages: [] as IMessage[],
  boxes: [] as IBox[]
}

export const useMessagingStore = defineStore("messagingStore", {
  state: () => ({
    messages: [] as IMessage[],
    boxes: [] as IBox[],
  }),
  actions: {
    async getMessages() {
      const result = await getMessages()
      if (result.ok) {
        const { boxes, messages } = result.payload
        // commit('setBoxes', boxes)
        this.setBoxes(boxes)
        // commit('setMessages', messages)
        this.setMessages(messages)
      }
      return result
    },
    async createNewMessage(payload: ICreateMessagePost) {
      let result = await createNewMessage(payload)
      if (!result.ok) {
        return result
      }
      result = await this.getMessages()
      return result
    },
    async replyMessage({ dispatch }, payload: IReplyMessagePost) {
      let result = await replyMessage(payload)
      if (!result.ok) {
        return result
      }
      result = await this.getMessages()
      return result
    },
    async messagesAction({ dispatch }, payload) {
      let result = await messagesAction(payload)
      if (!result.ok) {
        return result
      }
      result = await this.getMessages()
      return result
    },
    setMessagesStore(items) {
// console.log(' MESS store ')
// console.log(items)
      const { boxes, messages } = items
      this.boxes = boxes
      this.messages = messages
    },
    setBoxes(boxes) {
      this.boxes = boxes
    },
    setMessages(messages) {
      this.messages = messages
    },
  },
  getters: {
    // getBoxes: (state: IMessageState) => state.boxes,
    // getMessages: (state: IMessageState) => state.messages
  },

});



// const actions = {
//   async getMessages({ commit }) {
//     const result = await getMessages()
//     if (result.ok) {
//       const { boxes, messages } = result.payload
//       commit('setBoxes', boxes)
//       commit('setMessages', messages)
//     }
//     return result
//   },
//   async createNewMessage({ commit, dispatch }, payload: ICreateMessagePost) {
//     let result = await createNewMessage(payload)
//     if (!result.ok) {
//       return result
//     }
//     result = await dispatch('getMessages')
//     return result
//   },
//   async replyMessage({ dispatch }, payload: IReplyMessagePost) {
//     let result = await replyMessage(payload)
//     if (!result.ok) {
//       return result
//     }
//     result = await dispatch('getMessages')
//     return result
//   },
//   async messagesAction({ dispatch }, payload) {
//     let result = await messagesAction(payload)
//     if (!result.ok) {
//       return result
//     }
//     result = await dispatch('getMessages')
//     return result
//   }
// }

// const mutations = {
//   setMessagesStore(state, items) {
//     const { boxes, messages } = items
//     state.boxes = boxes
//     state.messages = messages
//   },
//   setBoxes(state, boxes) {
//     state.boxes = boxes
//   },
//   setMessages(state, messages) {
//     state.messages = messages
//   }
// }

// const getters = {
//   getBoxes: (state: IMessageState) => state.boxes,
//   getMessages: (state: IMessageState) => state.messages
// }

// export default {
//   state,
//   actions,
//   mutations,
//   getters
// }
